import {
  Arr
} from '../../../../lib/Array.lib';
import Definition, {
  DEFINITION_CATEGORY__TECHNICAL_SKILLS,
  DEFINITION_GROUP_ID__TECHNICAL_SKILLS__BACKEND,
  DEFINITION_GROUP_ID__TECHNICAL_SKILLS__CLOUD_TECH,
  DEFINITION_GROUP_ID__TECHNICAL_SKILLS__FRONTEND,
  DEFINITION_GROUP_ID__TECHNICAL_SKILLS__NO_SQL,
  DEFINITION_GROUP_ID__TECHNICAL_SKILLS__SQL_TECH
} from '../../../../lib/Definition';

export default function getTagIdsTechSkillsRelevant() {
  return Arr(
    Arr(
      Definition.getRawDef(
        DEFINITION_CATEGORY__TECHNICAL_SKILLS
      ).groups
    ).filter(
      ({ id: groupId }) => (
        [
          DEFINITION_GROUP_ID__TECHNICAL_SKILLS__FRONTEND,
          DEFINITION_GROUP_ID__TECHNICAL_SKILLS__BACKEND,
          DEFINITION_GROUP_ID__TECHNICAL_SKILLS__NO_SQL,
          DEFINITION_GROUP_ID__TECHNICAL_SKILLS__SQL_TECH,
          DEFINITION_GROUP_ID__TECHNICAL_SKILLS__CLOUD_TECH,
        ].includes(groupId)
      )
    ).map(
      ({ ids }) => (ids)
    )
  ).flat();
}